import { PaginationStateT, SetPaginationConfigT } from '../types/pagination.types'

export class Pagination implements PaginationStateT {
    current_page: number
    total_pages: number
    limit: number
    total_items: number

    constructor({ current_page, total_pages, limit, total_items }: SetPaginationConfigT) {
        this.current_page = current_page || 1
        this.total_pages = total_pages || 1
        this.limit = limit || 20
        this.total_items = total_items || 1
    }
}
